import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboCodRaza`, method: 'GET', body: null, token: token})
}
